module.exports = __webpack_public_path__ + "img/unity-import-animation.d7d689ed.png";